import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-drag-icon',
  templateUrl: 'drag-icon.component.html'
})
export class DragIconComponent {
  constructor() {}
}
